export default __webpack_public_path__ + "static/media/bg.522bcb83.png";